import Vue from 'vue'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import Vue2TouchEvents from 'vue2-touch-events'

import NProgress from 'nprogress'
import App from './App.vue'
import i18n from './lang/i18n'
import store from './store.js'
import * as VueMenu from '@hscmap/vue-menu'
// import CciTrackingPlugin from './tracking/CciTrackingPlugin'
import CciEventTrackingPlugin from './tracking/CciEventTrackingPlugin'
import CciPages from 'components/ccipages/CciPages.vue'
const CciArticleContainer = () => import(/* webpackPrefetch: true */ 'components/cciarticlecontainer/CciArticleContainer.vue')
const CciArticleListMobile = () => import('components/cciarticlelistmobile/CciArticleListMobile.vue')
const CciArticle = () => import(/* webpackPrefetch: true */ 'components/cciarticle/CciArticle.vue')
const CciError = () => import('./CciError.vue')

/* eslint-disable no-new */
Vue.use(VueRouter)
Vue.use(VueResource)
Vue.use(VueMenu)
Vue.use(Vue2TouchEvents)

Vue.http.interceptors.push((request, next) => {
  NProgress.start()
  if (request.url.indexOf('cciobjects.json') !== -1) {
    // Bypass browser cache by adding time as a query param.
    request.url += (request.url.indexOf('?') > 0 ? '&' : '?') + `cb=${new Date().getTime()}`
  }
  next(() => {
    NProgress.done()
  })
})

store.state.homeUrl = document.referrer

var path = window.location.href
// var path = 'https://whitedot.poc.ccieurope.com/ccidist-replica-reader/?epub=https://whitedot.poc.ccieurope.com/ccidist-ws/ccieurope/ccieurope_cue-journal/issues/348#/pages/1'
// var path = 'https://dd-qa2.rnd.cue.cloud/ccidist-replica-reader/?epub=https://dd-qa2.rnd.cue.cloud/ccidist-ws/ccieurope/ccieurope_cue_journal/issues/87/#/pages/1'
// var path = 'https://whitedot.poc.ccieurope.com/ccidist-replica-reader/?epub=https://whitedot.poc.ccieurope.com/ccidist-ws/stibodx/stibodx_tomorrow_today/issues/374#/pages/1'
// var path = 'https://dd-qa2.rnd.cue.cloud/ccidist-replica-reader/?epub=https://dd-qa2.rnd.cue.cloud/ccidist-ws/3.22/3.22_3.22_tt/issues/72/#/pages/1'
var parametersPath = path.split('?')[1]

var epubURL = parametersPath

if (epubURL !== undefined && epubURL.indexOf('epub') !== -1) {
  // remove # and everything after from the epubURL. This is when the page is reloaded.
  if (epubURL.indexOf('#') !== -1) {
    epubURL = epubURL.split('#')[0]
  }

  epubURL = decodeURIComponent(epubURL)

  // remove other parameters from epubURL (fx. page=1, article=1...)
  var queryParameters
  if (epubURL.indexOf('&') !== -1) {
    queryParameters = epubURL.split('&')
    epubURL = queryParameters[0]
  }

  // remove other parameters from epubURL (fx. page=1, article=1...)
  if (epubURL.indexOf('&') !== -1) {
    epubURL = epubURL.split('&')[0]
  }

  // if the entire path to cciobjects.json is in epubURL, then remove it so only the path to OPS remains.
  // else if the path does not contain the entire path to OPS, then we assume that it is at least the path to the issue folder, and add /OPS
  if (epubURL.indexOf('cciobjects.json') !== -1) {
    epubURL = epubURL.split('/')
    epubURL.pop()
    epubURL = epubURL.join('/')
  } else if (epubURL.indexOf('OPS') === -1) {
    // if (!epubURL.endsWith('/')) {
    if (!endsWithCompatible(epubURL, '/')) {
      epubURL = epubURL + '/OPS'
    } else {
      epubURL = epubURL + 'OPS'
    }
  }

  // Finally we remove epub= from the epubURL and append a forward slash
  epubURL = epubURL.replace('epub=', '')
  epubURL = epubURL + '/'

  store.state.opsUrl = epubURL

  // Get publication id
  var splittedEpubUrl = store.state.opsUrl.split('/')
  var publicationId = splittedEpubUrl[5]
  var orgId = publicationId.split('_')[0]
  publicationId = publicationId.replace(orgId, '').substr(1)
  store.state.publicationId = publicationId

  var startPage = '1'

  if (queryParameters !== undefined && queryParameters.length > 1) {
    for (var i = 0; i < queryParameters.length; i++) {
      var param = queryParameters[i]
      if (param.indexOf('page=') !== -1) {
        startPage = param.substr(5, param.length)
        path = path.replace('&' + param, '')
        if (startPage.indexOf('/') !== -1) {
          startPage = startPage.replace('/', '-')
        }
      } else if (queryParameters[i].indexOf('article=') !== -1) {
        var startArticleId = queryParameters[i].split('article=')[1]
        if (startArticleId !== 'undefined') {
          if (startArticleId.indexOf('+') !== -1) {
            startArticleId = startArticleId.split('+')[1].split('.html')[0]
          } else {
            startArticleId = startArticleId.split('.html')[0]
          }
          store.state.startArticleId = startArticleId
          path = path.replace('&' + queryParameters[i], '')
        }
      } else if (queryParameters[i].indexOf('token=') !== -1) {
        var token = queryParameters[i].split('token=')[1]
        if (token.indexOf('#') !== -1) {
          token = token.split('#')[0]
        }
        store.state.token = token
      }
    }
  }

  if (startPage === '0') {
    startPage = '1'
  }

  if (parametersPath.indexOf('#/error') !== -1) {
    // remove '#/error'. This happens if the reader is reloaded when on the error page.
    // We want to try again and show the right page when reloading at an error.
    parametersPath = parametersPath.split('#/error')[0]
    path = path.split('#/error')[0]
  }

  if (parametersPath.indexOf('#') === -1) {
    store.state.startPage = startPage
    path = path + '#/pages/' + startPage
    if (window.history.replaceState) {
      window.history.replaceState('', '', path)
    }
  } else if (parametersPath.indexOf('#/pages/') !== -1) {
    let routePageParam = parametersPath.split('#/pages/')[1]
    store.state.startPage = routePageParam
  }
}

function endsWithCompatible (string1, string2) {
  return (string1.lastIndexOf(string2) === (string1.length - string2.length))
}

const routes = [
  { path: '/pages/:pageNr', name: 'pages', component: CciPages },
  { path: '/articles/:articleNr', name: 'articles', component: CciArticleContainer },
  { path: '/articles-mobile', name: 'articles-mobile', component: CciArticleListMobile },
  { path: '/article-mobile/:articleNr', name: 'article-mobile', component: CciArticle },
  { path: '/error', name: 'error', component: CciError }
]

const router = new VueRouter({
  routes: routes
})

// Vue.use(CciTrackingPlugin)
Vue.use(CciEventTrackingPlugin)

Vue.prototype.$eventHub = new Vue()

Vue.mixin({
  methods: {
    getEncodedResourceUrl: function (resource, revTimeStamp) {
      if (resource === null) {
        return ''
      }
      if (resource.indexOf('Public/') !== -1) {
        let refToEncode = resource.split('Public/')[1]
        return store.state.opsUrl + 'Public/' + encodeURIComponent(refToEncode) + (refToEncode.indexOf('?') > 0 ? '&' : '?') + 'rev=' + revTimeStamp
      }
      return store.state.opsUrl + encodeURIComponent(resource) + (resource.indexOf('?') > 0 ? '&' : '?') + 'rev=' + revTimeStamp
    },
    getResourceUrl: function (resource, revTimeStamp) {
      if (resource === null) {
        return ''
      }
      if (resource.indexOf('Public/') !== -1) {
        let refToEncode = resource.split('Public/')[1]
        return store.state.opsUrl + 'Public/' + refToEncode + (refToEncode.indexOf('?') > 0 ? '&' : '?') + 'rev=' + revTimeStamp
      }
      return store.state.opsUrl + resource + (resource.indexOf('?') > 0 ? '&' : '?') + 'rev=' + revTimeStamp
    },
    isDesktop: function () {
      let userAgent = navigator.userAgent || navigator.vendor || window.opera
      let androidOrIos = /android/i.test(userAgent) || (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream)

      if (androidOrIos) {
        return false
      }

      if (this.isTouchBrowser() && this.isSafari()) {
        return false
      }
      return true
    },
    isTouchBrowser: function () {
      var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ')
      var mq = function (query) {
        return window.matchMedia(query).matches
      }
      /* eslint-disable no-undef */
      if (('ontouchstart' in window) || (window.DocumentTouch && document instanceof DocumentTouch)) {
        return true
      }
      /* eslint-enable no-undef */
      // include the 'heartz' as a way to have a non matching MQ to help terminate the join
      // https://git.io/vznFH
      var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('')
      return mq(query)
    },
    isSafari: function () {
      let userAgent = navigator.userAgent || navigator.vendor || window.opera
      return /Safari/i.test(userAgent) && userAgent.indexOf('Chrome') === -1
    },
    isPhone: function () {
      return !this.isDesktop() && ((window.innerWidth < 850 && window.innerHeight < 450) || (window.innerWidth < 450 && window.innerHeight < 850))
    },
    isPortrait: function () {
      return window.innerHeight > window.innerWidth
    },
    isPhonePortrait: function () {
      return this.isPhone() && this.isPortrait()
    },
    isPhoneLandscape: function () {
      return this.isPhone() && !this.isPortrait()
    },
    isTablet: function () {
      return !this.isDesktop() && !this.isPhone()
    },
    isTabletPortrait: function () {
      return this.isTablet() && this.isPortrait()
    },
    isTabletLandscape: function () {
      return this.isTablet() && !this.isPortrait()
    }
  }
})

new Vue({
  el: '#app',
  i18n,
  router,
  store,
  template: '<App/>',
  components: { App }
})
